import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isActive"];
// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template-activatable/src/index.tsx
import React from 'react';
import baseIcon, { navigationActivatableDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
import useDeprecationWarning from '@bubble-ui/hook-use-deprecation-warning';
var NavigationIconAssistantPath = 'M7 4.5c-1.654 0-3 1.346-3 3v19.635l3.114-2.393A6.036 6.036 0 0110.77 23.5H23c1.654 0 3-1.346 3-3v-16H7zm17 16c0 .551-.449 1-1 1H10.77A8.047 8.047 0 006 23.077V7.5c0-.551.449-1 1-1h17v14zm-9-10a1.335 1.335 0 01.63 2.509C14.625 13.55 14 14.646 14 15.87h2c0-.479.227-.911.578-1.1a3.33 3.33 0 001.755-2.937A3.337 3.337 0 0015 8.5a3.337 3.337 0 00-3.333 3.333h2c0-.735.598-1.333 1.333-1.333zm1 9v-2h-2v2h2z';
var NavigationIconAssistantActivePath = 'M16.5781,14.77 C16.2271,14.959 16.0001,15.391 16.0001,15.87 L14.0001,15.87 C14.0001,14.646 14.6241,13.55 15.6301,13.009 C16.0641,12.775 16.3331,12.325 16.3331,11.833 C16.3331,11.098 15.7351,10.5 15.0001,10.5 C14.2651,10.5 13.6661,11.098 13.6661,11.833 L11.6661,11.833 C11.6661,9.996 13.1621,8.5 15.0001,8.5 C16.8381,8.5 18.3331,9.996 18.3331,11.833 C18.3331,13.062 17.6611,14.187 16.5781,14.77 L16.5781,14.77 Z M14.0001,19.5 L16.0001,19.5 L16.0001,17.5 L14.0001,17.5 L14.0001,19.5 Z M7.0001,4.5 C5.3461,4.5 4.0001,5.846 4.0001,7.5 L4.0001,27.135 L7.1141,24.742 C8.1571,23.941 9.4551,23.5 10.7701,23.5 L23.0001,23.5 C24.6541,23.5 26.0001,22.154 26.0001,20.5 L26.0001,4.5 L7.0001,4.5 Z';
var NavigationIcon = baseIcon('NavigationIconAssistant', {
  getPath: _ref => {
    var {
      isActive
    } = _ref;
    return isActive ? NavigationIconAssistantActivePath : NavigationIconAssistantPath;
  },
  styleSheetPropsGetter: (_ref2, designVersion) => {
    var {
      isActive,
      color,
      colorToken,
      colorTokenArgs
    } = _ref2;
    return {
      isActive,
      color,
      designVersion,
      colorToken,
      colorTokenArgs
    };
  },
  defaultStyleSheetGetter: navigationActivatableDefaultStyleSheetGetter,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  restOfPropsSanitizer: _ref3 => {
    var {
        isActive
      } = _ref3,
      restOfProps = _objectWithoutProperties(_ref3, _excluded);
    return restOfProps;
  },
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
var NavigationIconAssistant = props => {
  useDeprecationWarning({
    componentName: 'NavigationIconAssistant',
    removalDate: 'v6.0.0'
  });
  return /*#__PURE__*/React.createElement(NavigationIcon, props);
};
NavigationIconAssistant.displayName = 'NavigationIconAssistant';
export default NavigationIconAssistant;
//# sourceMappingURL=index.js.map